import { SELECTORS, SSO_API_PARAMS, SSO_TOKEN_API_URL } from './utils/constants';

export default class MakePayment {
  private readonly formMakePayment;
  private readonly quoteNumberInput;
  private readonly zipCodeInput;
  private readonly formErrorMessageWrapper;
  private readonly redirectButton;

  private readonly submitButton;
  private readonly waiterWrapper;
  private readonly chaseForm;

  constructor(paymentForm: HTMLFormElement) {
    this.formMakePayment = paymentForm;
    this.quoteNumberInput = this.formMakePayment.querySelector(SELECTORS.quoteNumber) as HTMLInputElement;
    this.zipCodeInput = this.formMakePayment.querySelector(SELECTORS.zipCode) as HTMLInputElement;
    this.formErrorMessageWrapper = this.formMakePayment.querySelector(SELECTORS.formError) as HTMLElement;
    this.submitButton = this.formMakePayment.querySelector(SELECTORS.submitButton) as HTMLButtonElement;

    this.waiterWrapper = this.formMakePayment.querySelector(SELECTORS.formLoader) as HTMLElement;

    // Chase form
    this.chaseForm = document.querySelector(SELECTORS.chaseForm) as HTMLFormElement;

    this.redirectButton = document.querySelector(SELECTORS.redirectButton) as HTMLAnchorElement;

    // Listen to Event
    this.listener();
  }

  /**
   * This is supposed to enable the Paymentus workflow on the Webflow site, should be
   * used for testing purposes. Needs to be refactored before deploying.
   */
  private async testPaymentusGateway(policy_value: string, zip_value: string) {
    // Data required by API spec
    const tokenURL = new URL(SSO_TOKEN_API_URL);
    const policyNumber = { name: SSO_API_PARAMS.policyNumberName, value: policy_value }; // default: 172615
    const mailZip = { name: SSO_API_PARAMS.mailZipName, value: zip_value }; // default: 6839

    tokenURL.searchParams.append(policyNumber.name, policyNumber.value);
    tokenURL.searchParams.append(mailZip.name, mailZip.value);

    // Display loader while fetching the token
    this.displayLoader(true);
    this.displayError(false);
    this.displayErrorState(false);
    this.displaySubmitButton(false);

    // Remove any existing hidden input before adding a new one
    const existingHiddenInput = this.chaseForm.querySelector('#itok');
    if (existingHiddenInput) {
      this.chaseForm.removeChild(existingHiddenInput);
    }

    // Get TOKEN from API
    try {
      const response = await fetch(tokenURL);

      if (!response.ok) {
        throw new Error(`Http error! status: ${response.status}`);
      }

      const token = (await response.text()).replace(/"/g, '');
      console.log(`Received token for ${policyNumber.value}, ${mailZip.value}:  ${token}`);

      // If response is -1, the backend don't have info about this key pair
      if (token === '-1') {
        this.displayLoader(false);
        this.displayErrorState(true);
        this.displaySubmitButton(true);
        this.displayError();
        return;
      }

      // add token as a query parameter to the redirect button href
      const url = new URL(this.redirectButton.href);
      url.searchParams.set('token', token);
      this.redirectButton.href = url.href;

      // Open the chase form tab
      this.redirectButton.click();
      this.displayLoader(false);
      this.displaySubmitButton(true);
    } catch (err) {
      this.displayLoader(false);
      this.displayError();
    }
  }

  private listener() {
    // Listen to click event of the submit button
    this.formMakePayment.addEventListener('submit', (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();
      e.stopPropagation();

      if (this.quoteNumberInput.value !== '' && this.zipCodeInput.value !== '') {
        // fetch SSO token, populate it in the chase form and submit chase form
        this.testPaymentusGateway(this.quoteNumberInput.value, this.zipCodeInput.value);
      }
    });
  }

  /**
   * Shows/hides the error message.
   * @param display Defines if it should be shown or hidden.
   */
  private displayError(display = true) {
    this.formErrorMessageWrapper.style.display = display ? 'flex' : 'none';
  }

  /**
   * Shows/hides the spining loader.
   * @param display Defines if it should be shown or hidden.
   */
  private displayLoader(display = true) {
    this.waiterWrapper.style.display = display ? 'flex' : 'none';
  }

  /**
   * Shows/hides the submit button.
   * @param display Defines if it should be shown or hidden.
   */
  private displaySubmitButton(display = true) {
    this.submitButton.style.display = display ? 'flex' : 'none';
  }

  /**
   * Shows the error state on the input fields.
   * @param display
   */
  private displayErrorState(display = true) {
    if (display) {
      this.quoteNumberInput.classList.add(SELECTORS.errorClass);
      this.zipCodeInput.classList.add(SELECTORS.errorClass);
    } else {
      this.quoteNumberInput.classList.remove(SELECTORS.errorClass);
      this.zipCodeInput.classList.remove(SELECTORS.errorClass);
    }
  }
}
